import { getDoc, doc } from "firebase/firestore"
import { useLocation } from "react-router-dom"
import ItemDisplay from "./ItemDisplay"
import { db } from "../../firebase"
import { useEffect, useState, useContext } from "react"
import { AuthContext } from "../../context/AuthContext"
import ItemDisplaySkeleton from "./ItemDisplaySkeleton"

const ItemDisplayContainer = () => {
    const { currentUser } = useContext(AuthContext)
    const location = useLocation()
    console.log(location.pathname.split('/').at(-1))
    const listingId = location.pathname.split('/').at(-1)
    // const {listing_id} = location.state
    // const listingId = localStorage.getItem("listingId")
    // console.log(listingId)
    // console.log(localStorage)
    // localStorage.removeItem("listingId")
    // console.log(localStorage)
    const [listing, setListing] = useState(null)
    const getListing = async () => {
        let listingData
        let privateInfoData
        try {
            await getDoc(doc(db, "listings", listingId))
            .then((res) => {
                listingData = res.data()
                console.log(listingData)
            })
            if (currentUser && listingData && listingData.user.userId === currentUser.uid) {
                try {
                    await getDoc(doc(db,`listings/${listingId}/private`, "data"))
                        .then(privateInfo => {
                            privateInfoData = privateInfo.data()
                            console.log(privateInfoData)
                            console.log({...listingData, ...privateInfoData})
                            setListing({...listingData, ...privateInfoData})
                        })
                } catch(err) {
                     console.error(err.message)
                }
            } else {
                console.log(listingData)
                setListing(listingData)
            }
        } catch(err) {
             console.error(err.message)
        }
    }

    useEffect(() => {
        getListing()
    }, [])

    return (
        <div className="item-display-container page-content">
            {listing ? <ItemDisplay listing={listing}/> : 
                listing === null ? <ItemDisplaySkeleton/> : <div style={{margin: "auto"}}>No listing found</div>
            }
        </div>
    )
}

export default ItemDisplayContainer